export const computedMapDict = function () {
    return {
        // 外集卡
        _dictApplyType: () => [...applyType],
        _dictTaskState: () => [...taskState],
        _dictApplyState: () => [...applyState],
        _dictBackFeeState: () => [...backFeeState],
        _dictIfHandle: () => [...ifHandle],
        _dictPayType: () => [...payType],
        _dictFeeType: () => [...feeType],
        _dictFeeType2: () => [...feeType2],
        _dictSettleStatus: () => [...settleStatus],
        _dictApplyAuditState: () => [...applyAuditState],
        _dictCfsTaskType: () => [...cfsTaskType],
        _dictCfsZxType: () => [...cfsZxType],
        _dictFeeApplyType: () => [...feeApplyType],
		_dictFeeApplyType2: () => [...feeApplyType2],
        _dictIfAudit: () => [...ifAudit],
        _dictTastAuditState: () => [...tastAuditState],
        _dictCommandStatus1: () => [...commandStatus1],
        _dictTaskObjective: () => [...taskObjective],
        _dictTaskAction: () => [...taskAction],
        _dictCntStatus: (key) => [...cntStatus],
        _dictMessageType: (key) => [...messageType],
        _dictTaskStatus: (key) => [...taskStatus],
        _dictTransType: (key) => [...transType],

        // 老数据
        _dictCustomType: () => [...customType],
        _dictBankType: () => [...bankType],
        _dictCompanyNature: () => [...companyNature],
        _dictTrueOrFalse: () => [...trueOrFalse],
        _dictOneOrZero: () => [...oneOrZero],
        _dictAllOrNone: () => [...allOrNone],
        _dictContractType: () => [...contractType],
        _dictContractAttribute: () => [...contractAttribute],
        _dictContractStatus: () => [...contractStatus],
        _dictJhContractStatus: () => [...jhContractStatus],
        _dictUseOrUnused: () => [...useOrUnused],
        _dictBusinessModel: () => [...businessModel],
        _dictCostStandardType: () => [...costStandardType],
        _dictStandSettlementType: () => [...standSettlementType],
        _dictProjectType: () => [...projectType],
        _dictProjectStatus: () => [...projectStatus],
        _dictEnableType: () => [...enableType],
        _dictParamType: () => [...paramType],
        _dictPortAndStationType: () => [...portAndStationType],
        _dictEntrustType: () => [...entrustType],
        _dictValidType: () => [...validType],
        _dictPlanType: () => [...planType],
        _dictEntrustStatus: () => [...entrustStatus],
        _dictIfHeavyType: () => [...ifHeavyType],
        _dictTradeType: () => [...tradeType],
        _dictOrgStatusType: () => [...orgStatusType],
        _dictAccountStatus: () => [...accountStatus],
        _dictSexType: () => [...sexType],
        _dictDicType: () => [...dicType],
        _dictPlanStatus: () => [...planStatus],
        _dictPackingWay: () => [...packingWay],
        _dictSpecify: () => [...specify],
        _dictJobStatus: () => [...jobStatus],
        _dictContainerJobType: () => [...containerJobType],
        _dictExcelFieldTypes: () => [...excelFieldTypes],
        _dictPriorityType: () => [...priorityType],
        _dictPriorityTypes: () => [...priorityTypes],
        _dictOperatorType: () => [...operatorType],
        _dictOperatorTwoType: () => [...operatorTwoType],
        _dictAttrType: () => [...attrType],
        _dictSOrB: () => [...sOrB],
        _dictJobStatusFilter: () => [...jobStatusFilter],
        _dictStackOrder: () => [...stackOrder],
        _dictImportAndExportType: () => [...importAndExportType],
        _dictImportAndExportTypeByIO: () => [...importAndExportTypeByIO],
        _dictImportExport: () => [...importExport],
        _dictEntrustNoType: () => [...entrustNoType],
        _dictContainerStatus: () => [...containerStatus],
        _dictCommandStatus: () => [...commandStatus],
        _dictJobPurpose: () => [...jobPurpose],
        _dictRegisterType: () => [...registerType],
        _dictJobAction: () => [...jobAction],
        _dictYardPlanType: () => [...yardPlanType],
        _dictShipType: () => [...shipType],
        _dictShipPlanStatus: () => [...shipPlanStatus],
        _dictIsFinish: () => [...isFinish],
        _dictTsJobStatus: () => [...tsJobStatus],
        _dictTallyPlanStatus: () => [...tallyPlanStatus],
        _dictPortCode: () => [...portCode],
        _dictShipPlanType: () => [...shipPlanType],
        _dictEnchaseWayType: () => [...enchaseWayType],
        _dictIsChange: () => [...isChange],
        _dictReleaseType: () => [...releaseType],
        _dictSettlementType: () => [...settlementType],
        _dictBusinessModule: () => [...businessModule],
        _dictRuleOperator: () => [...ruleOperator],
        _dictRuleOperatorType: () => [...ruleOperatorType],
        _dictRuleConnect: () => [...ruleConnect],
        _dictFeeUnit: () => [...feeUnit],
        _dictDamaged: () => [...damaged],
        _dictPlanReport: () => [...planReport],
        // _dictTaskType: () => [...taskType],
        _dictAccountChangeWay: () => [...accountChangeWay],
        _dictAllJobStatus: () => [...allJobStatus],
        _dictAllJobStatusNew: () => [...allJobStatusNew],
        _dictOperationState: () => [...operationState],
        _dictWarehouse: () => [...warehouse],
        _dictAreaType: () => [...areaType],
        _dictPrinciple: () => [...principle],
        _dictPriority: () => [...priority],
        // _dictManagement: () => [...management],
        // _dictPutStyle: () => [...putStyle],
        _dictLimitFactor: () => [...limitFactor],
        _dictCalendarType: () => [...calendarType],
        _dictBusinessMode: () => [...businessMode],
        _dictRuleCondition: () => [...ruleCondition],
        _dictRuleCondition2: () => [...ruleCondition2],
        _dictCardType: () => [...cardType],
        _dictUseStatus: () => [...useStatus],
        // _dictProductName: () => [...productName],
        // _dictFormat1: () => [...format1],
        // _dictFormat2: () => [...format2],
        // _dictFormat3: () => [...format3],
        // _dictQuality: () => [...quality],
        // _dictMeterStyle: () => [...meterStyle],
        _dictAccountTypes: () => [...accountTypes],
        // _dictManufactor: () => [...manufactor],
        _dictAccountType: () => [...accountType],
        _dictAccountNature: () => [...accountNature],
        // _dictRoomType: () => [...roomType],
        // _dictWorkMode: () => [...workMode],
        _dictOverdueType: () => [...overdueType],
        // _dictInSettleStyle: () => [...inSettleStyle],
        // _dictOutSettleStyle: () => [...outSettleStyle],
        // _dictControlWay: () => [...controlWay],
        // _dictControlType: () => [...controlType],
        // _dictControlStatus: () => [...controlStatus],
        // _dictAuditStatus: () => [...auditStatus],
        // _dictAccountPageType: () => [...accountPageType],
        // _dictAdjustWay: () => [...adjustWay],
        // _dictAdjustStatus: () => [...adjustStatus],
        _dictIsDamagedType: () => [...isDamagedType],
        _dictPreStatus: () => [...preStatus],
        _dictPreStatus2: () => [...preStatus2],
        // _dictStockStatus: () => [...stockStatus],
        // _dictHandleStatus: () => [...handleStatus],
        // _dictRelocationType: () => [...relocationType],
        // _dictCountNumUnitEnum: () => [...countNumUnitEnum],
        // _dictShiftStatus: () => [...shiftStatus],
        // _dictCheckStatus: () => [...checkStatus],
        // _dictPresource: () => [...presource],
        // _dictAddPresource: () => [...addPresource],
        // _dictOutWay: () => [...outWay],
        // _dictLimitRange: () => [...limitRange],
        // _dictStockType: () => [...stockType],
        // _dictBillStatus: () => [...billStatus],
        // _dictBillAuditStatus: () => [...billAuditStatus],
        // _dictOutBillStatus: () => [...OutBillStatus],
        // _dictBusinessType: () => [...businessType],
        // _dictBookStatus: () => [...bookStatus],
        // _dictInwayStatus: () => [...inwayStatus],
        // _dictGateStatus: () => [...gateStatus],
        // _dictCargoFromStatus: () => [...cargoFromStatus],
        // _dictMachiningModeStatus: () => [...machiningModeStatus],
        _dictInOutType: () => [...inOutType],
        // _dictPackageMode: () => [...packageMode],
        _dictAllOrPart: () => [...allOrPart],
        // _dictInOutWay: () => [...inOutWay],
        // _dictOrderStatus: () => [...orderStatus],
        // _dictPiecesType: () => [...piecesType],
        // _dictNewPiecesType: () => [...newPiecesType],
        // _dictPayWay: () => [...payWay],
        // _dictChargeType: () => [...chargeType],
        // _dictInSettlementMode: () => [...inSettlementMode],
		// _dictDuiOutWay: () => [...duiOutWay],
        // _dictHasOutWay: () => [...hasOutWay],
        // _dictOriOutWay: () => [...oriOutWay],
        _dictNewAccountNature: () => [...newAccountNature],
        // _dictPrePaymentStatus: () => [...prePaymentStatus],
        // _dictSettleWay: () => [...settleWay],
        // _dictNewSettleWay: () => [...newSettleWay],
        // _dictWriteOfWay: () => [...writeOfWay],
        // _dictRecordType: () => [...recordType],
        // _dictAuthorizeType: () => [...authorizeType],
        // _dictPowerType: () => [...powerType],
        _dictThType: () => [...thType],
        _dictCarAuditState: () => [...carAuditState],
    }
}
export const filtersMapDict = function () {
    return {
        // 外集卡
        _filterApplyType: (key) => applyType.get(key),
        _filterTaskState: (key) => taskState.get(key),
        _filterApplyState: (key) => applyState.get(key),
        _filterBackFeeState: (key) => backFeeState.get(key),
        _filterIfHandle: (key) => ifHandle.get(key),
        _filterPayType: (key) => payType.get(key),
        _filterFeeType: (key) => feeType.get(key),
        _filterFeeType2: (key) => feeType2.get(key),
        _filterSettleStatus: (key) => settleStatus.get(key),
        _filterApplyAuditState: (key) => applyAuditState.get(key),
        _filterCfsTaskType: (key) => cfsTaskType.get(key),
        _filterCfsZxType: (key) => cfsZxType.get(key),
        _filterFeeApplyType: (key) => feeApplyType.get(key),
        _filterIfAudit: (key) => ifAudit.get(key),
        _filterTastAuditState: (key) => tastAuditState.get(key),
        _filterCommandStatus1: (key) => commandStatus1.get(key),
        _filterTaskObjective: (key) => taskObjective.get(key),
        _filterTaskAction: (key) => taskAction.get(key),
        _filterCntStatus: (key) => cntStatus.get(key),
        _filterTaskStatus: (key) => taskStatus.get(key),
        _filterTransType: (key) => transType.get(key),
        // 老数据
        _filterCustomType: (key) => customType.get(key),
        _filterBankType: (key) => bankType.get(key),
        _filterCompanyNature: (key) => companyNature.get(key),
        _filterTrueOrFalse: (key) => trueOrFalse.get(key),
        _filterAllOrNone: (key) => allOrNone.get(key),
        _filterOneOrZero: (key) => oneOrZero.get(key),
        _filterContractType: (key) => contractType.get(key),
        _filterContractAttribute: (key) => contractAttribute.get(key),
        _filterContractStatus: (key) => contractStatus.get(key),
        _filterJhContractStatus: (key) => jhContractStatus.get(key),
        _filterUseOrUnused: (key) => useOrUnused.get(key),
        _filterBusinessModel: (key) => businessModel.get(key),
        _filterCostStandardType: (key) => costStandardType.get(key),
        _filterStandSettlementType: (key) => standSettlementType.get(key),
        _filterProjectType: (key) => projectType.get(key),
        _filterProjectStatus: (key) => projectStatus.get(key),
        _filterEnableType: (key) => enableType.get(key),
        _filterParamType: (key) => paramType.get(key),
        _filterPortAndStationType: (key) => portAndStationType.get(key),
        _filterEntrustType: (key) => entrustType.get(key),
        _filterValidType: (key) => validType.get(key),
        _filterPlanType: (key) => planType.get(key),
        _filterEntrustStatus: (key) => entrustStatus.get(key),
        _filterIfHeavyType: (key) => ifHeavyType.get(key),
        _filterTradeType: (key) => tradeType.get(key),
        _filterOrgStatusType: (key) => orgStatusType.get(key),
        _filterAccountType: (key) => accountType.get(key),
        _filterAccountTypes: (key) => accountTypes.get(key),
        _filterAccountStatus: (key) => accountStatus.get(key),
        _filterSexType: (key) => sexType.get(key),
        _filterDicType: (key) => dicType.get(key),
        _filterPlanStatus: (key) => planStatus.get(key),
        _filterExcelFieldTypes: (key) => excelFieldTypes.get(key),
        _filterPackingWay: (key) => packingWay.get(key),
        _filterSpecify: (key) => specify.get(key),
        _filterJobStatus: (key) => jobStatus.get(key),
        _filterJobStatusFilter: (key) => jobStatusFilter.get(key),
        _filterContainerJobType: (key) => containerJobType.get(key),
        _filterOperatorType: (key) => operatorType.get(key),
        _filterOperatorTwoType: (key) => operatorTwoType.get(key),
        _filterAttrType: (key) => attrType.get(key),
        _filterSOrB: (key) => sOrB.get(key),
        _filterStackOrder: (key) => stackOrder.get(key),
        _filterImportAndExportType: (key) => importAndExportType.get(key),
        _filterImportExport: (key) => importExport.get(key),
        _filterContainerStatus: (key) => containerStatus.get(key),
        _filterCommandStatus: (key) => commandStatus.get(key),
        _filterJobPurpose: (key) => jobPurpose.get(key),
        _filterRegisterType: (key) => registerType.get(key),
        _filterJobAction: (key) => jobAction.get(key),
        _filterYardPlanType: (key) => yardPlanType.get(key),
        _filterShipType: (key) => shipType.get(key),
        _filterShipPlanStatus: (key) => shipPlanStatus.get(key),
        _filterIsFinish: (key) => isFinish.get(key),
        _filterTsJobStatus: (key) => tsJobStatus.get(key),
        _filterTsJobStatusNew: (key) => tsJobStatusNew.get(key),
        _filterAllJobStatus: (key) => allJobStatus.get(key),
        _filterAllJobStatusNew: (key) => allJobStatusNew.get(key),
        _filterTallyPlanStatus: (key) => tallyPlanStatus.get(key),
        _filterPortCode: (key) => portCode.get(key),
        _filterShipPlanType: (key) => shipPlanType.get(key),
        _filterEnchaseWayType: (key) => enchaseWayType.get(key),
        _filterIsChange: (key) => isChange.get(key),
        _filterReleaseType: (key) => releaseType.get(key),
        _filterSettlementType: (key) => settlementType.get(key),
        _filterIsDamagedType: (key) => isDamagedType.get(key),
        _filterBusinessModule: (key) => businessModule.get(key),
        _filterRuleOperator: (key) => ruleOperator.get(key),
        _filterRuleOperatorType: (key) => ruleOperatorType.get(key),
        _filterRuleConnect: (key) => ruleConnect.get(key),
        _filterFeeUnit: (key) => feeUnit.get(key),
        _filterDamaged: (key) => damaged.get(key),
        _filterPlanReport: (key) => planReport.get(key),
        // _filterTaskType: (key) => taskType.get(key),
        _filterAccountChangeWay: (key) => accountChangeWay.get(key),
        _filterOperationState: (key) => operationState.get(key),
        _filterWarehouse: (key) => warehouse.get(key),
        _filterAreaType: (key) => areaType.get(key),
        _filterPrinciple: (key) => principle.get(key),
        _filterPriority: (key) => priority.get(key),
        // _filterManagement: (key) => management.get(key),
        // _filterPutStyle: (key) => putStyle.get(key),
        _filterLimitFactor: (key) => limitFactor.get(key),
        _filterCalendarType: (key) => calendarType.get(key),
        _filterBusinessMode: (key) => businessMode.get(key),
        _filterRuleCondition: (key) => ruleCondition.get(key),
        _filterRuleCondition2: (key) => ruleCondition2.get(key),
        _filterCardType: (key) => cardType.get(key),
        _filterUseStatus: (key) => useStatus.get(key),
        // _filterProductName: (key) => productName.get(key),
        // _filterFormat1: (key) => format1.get(key),
        // _filterFormat2: (key) => format2.get(key),
        // _filterFormat3: (key) => format3.get(key),
        // _filterQuality: (key) => quality.get(key),
        // _filterMeterStyle: (key) => meterStyle.get(key),
        // _filterManufactor: (key) => manufactor.get(key),
        // _filterRoomType: (key) => roomType.get(key),
        // _filterWorkMode: (key) => workMode.get(key),
        _filterOverdueType: (key) => overdueType.get(key),
        // _filterInSettleStyle: (key) => inSettleStyle.get(key),
        // _filterOutSettleStyle: (key) => outSettleStyle.get(key),
        // _filterControlWay: (key) => controlWay.get(key),
        // _filterControlType: (key) => controlType.get(key),
        // _filterControlStatus: (key) => controlStatus.get(key),
        // _filterAuditStatus: (key) => auditStatus.get(key),
        // _filterAccountPageType: (key) => accountPageType.get(key),
        // _filterAdjustWay: (key) => adjustWay.get(key),
        // _filterAdjustStatus: (key) => adjustStatus.get(key),
        _filterPreStatus: (key) => preStatus.get(key),
        _filterInWay: (key) => inWay.get(key),
        // _filterStockStatus: (key) => stockStatus.get(key),
        // _filterHandleStatus: (key) => handleStatus.get(key),
        // _filterRelocationType: (key) => relocationType.get(key),
        // _filterCountNumUnitEnum: (key) => countNumUnitEnum.get(key),
        // _filterShiftStatus: (key) => shiftStatus.get(key),
        // _filterCheckStatus: (key) => checkStatus.get(key),
        // _filterPresource: (key) => presource.get(key),
        // _filterAddPresource: (key) => addPresource.get(key),
        // _filterBusinessType: (key) => businessType.get(key),
        // _filterBookStatus: (key) => bookStatus.get(key),
        // _filterInwayStatus: (key) => inwayStatus.get(key),
        // _filterLimitRange: (key) => limitRange.get(key),
        // _filterStockType: (key) => stockType.get(key),
        // _filterOutWay: (key) => outWay.get(key),
        // _filterBillStatus: (key) => billStatus.get(key),
        // _filterBillAuditStatus: (key) => billAuditStatus.get(key),
        // _filterOutBillStatus: (key) => OutBillStatus.get(key),
        // _filterGateStatus: (key) => gateStatus.get(key),
        // _filterCargoFromStatus: (key) => cargoFromStatus.get(key),
        // _filterMachiningModeStatus: (key) => machiningModeStatus.get(key),
        _filterInOutType: (key) => inOutType.get(key),
        // _filterPackageMode: (key) => packageMode.get(key),
        _filterAllOrPart: (key) => allOrPart.get(key),
        // _filterInOutWay: (key) => inOutWay.get(key),
        // _filterOrderStatus: (key) => orderStatus.get(key),
        // _filterPiecesType: (key) => piecesType.get(key),
        // _filterNewPiecesType: (key) => newPiecesType.get(key),
        // _filterPayWay: (key) => payWay.get(key),
        _filterAccountNature: (key) => accountNature.get(key),
        // _filterChargeType: (key) => chargeType.get(key),
        // _filterInSettlementMode: (key) => inSettlementMode.get(key),
        // _filterPrePaymentStatus: (key) => prePaymentStatus.get(key),
        // _filterSettleWay: (key) => settleWay.get(key),
        // _filterNewSettleWay: (key) => newSettleWay.get(key),
        // _filterWriteOfWay: (key) => writeOfWay.get(key),
        // _filterRecordType: (key) => recordType.get(key),
        // _filterDuiOutWay: (key) => duiOutWay.get(key),
        // _filterHasOutWay: (key) => hasOutWay.get(key),
        // _filterOriOutWay: (key) => oriOutWay.get(key),
        // _filterAuthorizeType: (key) => authorizeType.get(key),
        // _filterPowerType: (key) => powerType.get(key),
        _filterThType: (key) => thType.get(key),
        _filterCarAuditState: (key) => carAuditState.get(key),
        _filterMessageType: (key) => messageType.get(key),
        _filterImportAndExportTypeByIO: (key) => importAndExportTypeByIO.get(key),



        _filtercontainerUseType: (key) => containerUseType.get(key),
        _filterorderStatus: (key) => orderStatus.get(key),
        _filterorderWagonState: (key) => orderWagonState.get(key),
        _filterorderContainerState: (key) => orderContainerState.get(key),
        _filterZYStatus: (key) => ZYStatus.get(key),
        _filterstatusType: (key) => statusType.get(key),
        _filteroperateCate: (key) => operateCate.get(key),
    }
}


/** ==========基础========= */
// 外集卡开始
// 放箱类型
export const applyType = new Map([
    ['TK', '提空'],
    ['TZ', '提重'],
    ['JC', '进场'],
    ['ZX', '装箱'],
    ['CX', '拆箱']
])
// 费用类型  果园
export const feeApplyType = new Map([
    ['ZC', '装船'],
    ['XC', '卸船'],
    ['ZX', '装箱'],
    ['CX', '拆箱'],
    ['JK', '进库'],
    ['CK', '出库'],
    ['TE', '提空'],
    ['TF', '提重'],
    ['JC', '外进'],
    ['TS', '特殊作业'],
    ['DZ', '捣载']
])

// 费用类型  渝巴
export const feeApplyType2 = new Map([
    ['ZC', '装火车'],
    ['XC', '卸火车'],
    ['ZX', '装箱'],
    ['CX', '拆箱'],
    ['JK', '进库'],
    ['CK', '出库'],
    ['TE', '提空'],
    ['TF', '提重'],
    ['JC', '外进'],
    ['TS', '特殊作业'],
    ['DZ', '捣载']
])

// 申请分配状态
export const applyState = new Map([
    ['NOTACCEPT', '未接收'],
    ['ACCEPTED', '已接收'],
    ['REFUSED', '已拒绝']
])
// 作业状态
export const taskState = new Map([
    ['NOTDISPATCH', '未分配'],
    ['NOTACCEPT', '待接收'],
    ['NOTWORK', '未作业'],
    ['WORKING', '作业中'],
    ['COMPLETED', '已完成']
])
// 结算装填
export const tastAuditState = new Map([
    ["UNSUBMIT","未提交"],
    ["UNAUDIT","已提交未审核"],
    ["CANCELED","已撤回"],
    ["AUDITED","审核通过"],
    ["NOTAUDIT","审核不通过"]
])
// 退款状态
export const backFeeState = new Map([
    ['0', '未审核'],
    ['1', '已退回'],
    ['2', '已审核'],
    ['3', '已退款']
])
// 是否处理
export const ifHandle = new Map([
    ['0', '未处理'],
    ['1', '已处理']
])
// 是否审核
export const ifAudit = new Map([
    ['0', '未审核'],
    ['1', '审核通过'],
    ['2', '审核不通过']
])
// 支付方式
export const payType = new Map([
    ['XJ', '现金'],
    ['YJ', '预付款']
])
// 费用类型
export const feeType = new Map([
    ['CZ', '充值'],
    ['KK', '扣款']
])
// 费用类型2
export const feeType2 = new Map([
    ['0', '开户'],
    ['1', '充值'],
    ['2', '退款'],
    ['3', '扣款']
])
// 结算装填
export const settleStatus = new Map([
    ['0', '未结算'],
    ['1', '已结算']
])
// 结算装填
export const applyAuditState = new Map([
    ['0', '未提交'],
    ['1', '已提交未审核'],
    ['2', '审核通过'],
    ['3', '审核不通过']
])
//集卡审核
export const carAuditState = new Map([
    ['0', '未审核'],
    ['1', '审核通过'],
    ['2', '退回']
])
//货站作业类型
export const cfsTaskType = new Map([
    ['RJ', '人机'],
    ['RL', '人力']
])
//货站装箱类型
export const cfsZxType = new Map([
    ['CZ', '车装'],
    ['DZ', '对装'],
    ['CKZ', '仓装']
])

//指令状态commandStatus;//指令状态；0-未作业，1-作业中，2-完成作业
export const commandStatus1 = new Map([
    ['0', '未作业'],
    ['1', '作业中'],
    ['2', '完成作业']
])
//指令作业木得1-进场，2 –提箱，3-装船，4-卸船，5-装箱出场，6-拆箱出场，7-装箱返场，8-拆箱返场, 9-特殊移返，0-特殊移箱，A-堆场整理
export const taskObjective = new Map([
    ['1', '进场'],
    ['2', '提箱'],
    ['3', '装船'],
    ['4', '卸船'],
    ['5', '装箱出场'],
    ['6', '拆箱出场'],
    ['7', '装箱返场'],
    ['8', '拆箱返场'],
    ['9', '特殊移返'],
    ['0', '特殊移箱'],
    ['A', '堆场整理']
])
//指令动作1-上架、2-下架、3-翻箱、4-移箱
export const taskAction = new Map([
    ['1', '上架'],
    ['2', '下架'],
    ['3', '翻箱'],
    ['4', '移箱']
])


// 老数据
// 客户类型
export const customType = new Map([
    ['NORMAL', '合同客户'],
    ['TEMP', '临时客户'],
])
// 银行账户类型
export const bankType = new Map([
    ['B', '基本账户'],
    ['G', '一般账户'],
])
// 企业性质
export const companyNature = new Map([
    ['GYQY', '国有企业'],
    ['COMPANY_SS', '上市企业'],
    ['COMPANY_MY', '民营企业'],
    ['COMPANY_HZ', '合资企业'],
    ['COMPANY_QT', '其他企业']
])
// 是或否
export const trueOrFalse = new Map([
    [true, '是'],
    [false, '否']
])
// 是或否全部加工
export const allOrPart = new Map([
    [true, '全部加工'],
    [false, '部分加工']
])
// 是或否
export const oneOrZero = new Map([
    ['1', '是'],
    ['0', '否']
])
// 有或无
export const allOrNone = new Map([
    [true, '有'],
    [false, '无']
])
// 合同类型
export const contractType = new Map([
    ['I', '收入合同'],
    ['O', '成本合同']
])
// 合同属性
export const contractAttribute = new Map([
    ['TSHT', '正式合同'],
    ['LSHT', '临时合同']
])
// 合同状态
export const contractStatus = new Map([
    // ['A','审批中'],
    ['C', '已生效'],
    ['D', '起草'],
    ['R', '退回'],
    ['S', '待签订'],
    ['V', '已作废'],
])
// 合同状态(件货)
export const jhContractStatus = new Map([
    ['A','审核中'],
    ['C', '已生效'],
    ['D', '起草'],
    ['R', '退回'],
    ['E', '已终止'],
])
// 合同使用状态
export const useOrUnused = new Map([
    [true, '已使用'],
    [false, '未使用']
])
// 业务模式
export const businessModel = new Map([
    // ['XHQHFK', '先货权后付款'],
    // ['DXCG', '定向采购'],
    // ['JBXS', '集并销售'],
    // ['HDFK', '货到付款'],
    // ['QCWL', '全程物流'],
    // ['DZZY', '吊装作业'],
    ['JZX', '集装箱业务'],
    ['JSH', '件散货业务']
])
// 结算标准??费用标准
export const costStandardType = new Map([
    ['BSTD', '基本标准'],
    ['CSTD', '合同标准'],
    // ['PSTD','项目标准'],
])
export const standSettlementType = new Map([
    ['B', '基本标准'],
    ['P', '项目标准'],
])
// 项目类型
export const projectType = new Map([
    ['NORMAL', '正式项目'],
    ['TEMP', '临时项目']
])
// 项目状态
export const projectStatus = new Map([
    ['D', '起草'],
    ['A', '审批中'],
    ['R', '退回'],
    ['Z', '已作废'],
    ['S', '已立项'],
    ['C', '执行中'],
    ['O', '已结束'],
    ['F', '已冻结'],
])

// 已启用或已禁用
export const enableType = new Map([
    [true, '已启用'],
    [false, '已禁用']
])

//箱状态
export const cntStatus = new Map([
    ['0','未到港'],
    ['1','已到港']
])

// 系统参数类型
export const paramType = new Map([
    ['B', '业务级'],
    ['S', '系统级'],
])

// 港口和站点
export const portAndStationType = new Map([
    ['P', '港口'],
    ['S', '站点'],
])

// 委托类型名称
export const entrustType = new Map([
    ['JCRK', '进场入库'],
    ['THCK', '提货出库'],
    ['CXWT', '拆箱委托'],
    ['BCWT', '补充进场入库'],
])

// 委托类型名称
export const packingWay = new Map([
    ['C', '集装箱'],
    ['B', '散货'],
    ['P', '件货']
])

// 委托状态
export const entrustStatus = new Map([
    ['NOACCEPT', '未受理'],
    ['ACCEPTED', '已受理'],
    ['VOID', '已作废'],
    ['OPERATING', '作业中'],
    ['FINISHED', '已完结'],
])
//预报状态
export const preStatus = new Map([
    ["NOACCEPT", "未确认"],
    //    ACCEPTED("ACCEPTED","已受理"),
    ["NOOPERATE", "未作业"],
    ["OPERATING", "作业中"],
    ["OPERATED", "已作业"],
    ["VOIDED", "已作废"],
    ["RETURNED", "已退回"],
    //    REVOKED("REVOKED","已撤回"),
    ["EXPIRED", "已过期"],
    //PENDING("PENDING","待复核"),
    ["FINISHED", "已完结"]
])

export const preStatus2 = new Map([
    ["NOACCEPT", "未确认"],
    ["NOOPERATE", "未作业"],
    ["OPERATING", "作业中"],
    ["FINISHED", "已完结"]
])

// 作业状态
export const jobStatus = new Map([
    ['NOOPERATE', '未作业'],
    ['RELEASE', '已发布'],
    ['VOIDED', '已作废'],
    ['OPERATING', '作业中'],
    ['OPERATED', '已作业'],
    ['CANCELLED', '已取消'],
])

// 过滤器
export const jobStatusFilter = new Map([
    ['NOOPERATE', '未作业'],
    ['RELEASE', '已发布'],
    ['VOIDED', '已作废'],
    ['OPERATING', '作业中'],
    ['OPERATED', '已作业'],
    ['CANCELLED', '已取消'],
    ['RETURNED', '已返场'],
    ['MOVED', '已移箱'],
])

// 是否空重
export const ifHeavyType = new Map([
    ['E', '空'],
    ['F', '重'],
])

// 内外贸
export const tradeType = new Map([
    ['I', '内贸'],
    ['O', '外贸'],
])

// 是否有效
export const validType = new Map([
    ['1', '有效'],
    ['0', '无效'],
])

// 运输方式
export const transType = new Map([
    ['TRAIN', '火车'],
    ['TR', '汽车']
])

// 出库方式
export const specify = new Map([
    [true, '指定箱'],
    [false, '大堆箱']
])

// 计划类型
export const planType = new Map([
    ['JCJH', '进场计划'],
    // ['CCJH', '出场计划'],
    ['CXJH', '拆箱计划'],
    ['ZXJH', '装箱计划'],
    ['NZRC', '内转入场计划'],
    ['NZCC', '内转出场计划'],
    ['ZCJH', '装车计划'],
    ['DDJH', '到达计划'],
    ['FYJH', '发运计划'],
    // ['XCJH', '卸车计划'],
    // ['ZSJH', '装船计划'],
    // ['XSJH', '卸船计划'],
    ['JGJH', '加工计划'],
    ['TXJH', '提箱计划'],
])

// 单位主体
export const orgStatusType = new Map([
    [true, '已启用'],
    [false, '已注销'],
])

export const accountType = new Map([
    ['M', '主账号'],
    ['S', '子账号'],
])

export const accountStatus = new Map([
    [true, '正常'],
    [false, '注销'],
])

export const sexType = new Map([
    ['MAN', '女'],
    ['WOMAN', '男'],
])

export const dicType = new Map([
    ['A', '数组'],
    ['D', '数据'],
])
// 计划作业状态
export const planStatus = new Map([
    ['NOOPERATE', '未作业'],
    ['OPERATING', '作业中'],
    ['COMPLETED', '已完成'],
    ['VOID', '已作废']
])
// 集装箱作业状态
export const containerJobType = new Map([
    ['IN_PORT', '进港'],
    ['OUT_PORT', '出港'],
    ['IN_TRANSFER', '内转入场'],
    ['OUT_TRANSFER', '内转出场'],
    ['IN_YARD', '进场'],
    ['OUT_YARD', '出场'],
    ['ZX', '装箱'],
    ['CX', '拆箱'],
])
// excel字段校验类型
export const excelFieldTypes = new Map([
    ['String', '字符串'],
    ['Int', '整数'],
    ['Float', '小数'],
    ['Enum', '枚举'],
    ['Date', '日期']
])

// 优先级
export const priorityType = new Map([
    ['1', '1'],
    ['2', '2'],
    ['3', '3'],
    ['4', '4'],
    ['5', '5'],
    ['6', '6'],
    ['7', '7'],
    ['8', '8'],
    ['9', '9'],
])
// 优先级 不可忽略
export const priorityTypes = new Map([
    [0, "不可忽略"],
    ["1", "1"],
    ["2", "2"],
    ["3", "3"],
    ["4", "4"],
    ["5", "5"],
    ["6", "6"],
    ["7", "7"],
    ["8", "8"],
    ["9", "9"]
]);
// 操作符
export const operatorType = new Map([
    ['EQ', '等于'],
    ['NE', '不等于'],
    ['CONTAIN', '包含'],
    ['NOTCONTAIN', '不包含'],
])
// 操作符-二期
export const operatorTwoType = new Map([
    ['EQ', '等于'],
    ['NE', '不等于'],
    ['CONTAIN', '包含'],
    ['NOTCONTAIN', '不包含'],
    ['ISNULL', '为空'],
    ['NOTNULL', '不为空'],
])
// 因素枚举
export const attrType = new Map([
    ['transportMode', '运输方式'],
    ['cargoName', '货名'],
    ['containerOwner', '箱主单位'],
    ['entrustFrom', '委托来源'],
    ['entrustOrgId', '委托单位'],
    ['containerType', '箱型'],
    ['stratStationCode', '发站'],
    ['ifHeavy', '空重'],
    ['importAndExport', '进出口'],
    ['containerSize', '尺寸'],
    ['tradeType', '内外贸'],
    ['containerNo', '箱号'],
])
// 是否在港
export const portStatusType = new Map([
    [true, '在港'],
    [false, '不在港'],
])
// 排序方向
export const sOrB = new Map([
    ['FSTB', '从小到大'],
    ['FBTS', '从大到小'],
])
// 堆放顺序
export const stackOrder = new Map([
    ['FTBR', '先层后排'],
    ['FRBT', '先排后层'],
])
// 进出口
export const importAndExportType = new Map([
    ['IM', '进口'],
    ['EX', '出口']
])
export const importAndExportTypeByIO = new Map([
    ['I', '进口'],
    ['O', '出口']
])

// 外理进出口
export const importExport = new Map([
    ['IM', '进口'],
    ['EX', '出口']
])
// 有无委托
export const entrustNoType = new Map([
    ['ISNULL', '无'],
    ['NOTNULL', '有']
])

// 箱状态
export const containerStatus = new Map([
    [true, '坏箱'],
    [false, '正常'],
])

// 指令状态
export const commandStatus = new Map([
    ["NOOPERATE", "未作业"],
    ["OPERATE", "作业中"],
    ["COMPLETED", "已完成"],
    ["VOID", "已作废"],
    ["EXPIRED", "已过期"],
])

// 作业目的
export const jobPurpose = new Map([
    ['TX', '提箱'],
    ['JC', '进场'],
    ['NZCC', '内转出场'],
    ['NZRC', '内转入场'],
    ['DCZL', '堆场整理'],
    ['CXYX', '拆箱移箱'],
    ['CXFC', '拆箱返场'],
])

// 登记类型
export const registerType = new Map([
    ['THCC', '提货出场'],
    ['JCRC', '进场入库'],
])

// 动作
export const jobAction = new Map([
    ['XCLD', '卸车落地'],
    ['XCSJ', '卸车上架'],
    ['ZT', '装车'],
    ['SJ', '上架'],
    ['XJLD', '下架落地'],
    ['XJZT', '下架装车'],
    ['FX', '翻箱'],
    ['YX', '移箱'],
])

// 堆场策划类型
export const yardPlanType = new Map([
    ['JKZX', '进口重箱策划'],
    ['JKKX', '进口空箱策划'],
    ['CKZX', '出口重箱策划'],
    ['CKKX', '出口空箱策划'],
    ['DDTX', '大堆提箱策划'],
])

// 船舶类型
export const shipType = new Map([
    ['CONTAINER', '集装箱船'],
    ['CARGO', '件散货船'],
])

// 外理-作业状态
export const shipPlanStatus = new Map([
    ['ONE', '未作业'],
    ['TWO', '作业中'],
    ['THREE', '退回作业'],
    ['FOUR', '理箱完成'],
    ['FIVE', '外理封航'],
    ['SIX', '拆提封航'],
])
//调整方式
export const accountChangeWay = new Map([
    ['ADD', '增补'],
    ['REDUCE', '扣减']
])

// 是否完成
export const isFinish = new Map([
    [true, '已完成'],
    [false, '未完成'],
])
// 作业状态
export const operationState = new Map([
    ['ONE', '未作业'],
    ['TWO', '作业中'],
    ['THREE', '已完成'],
    ['FOUR', '已审核'],
])

// 特殊箱作业类型
export const tsJobStatus = new Map([
    ['XZ', '熏蒸'],
    ['EZ', '二转'],
    // ['ZX','装箱'],
    // ['CX','拆箱'],
    ['OTHER', '其它'],
])

// 特殊箱作业类型
export const tsJobStatusNew = new Map([
    ['XZ', '熏蒸'],
    ['EZ', '二转'],
    ['ZX', '装箱'],
    ['CX', '拆箱'],
    ['OTHER', '其它'],
    ['CHANGE', '调账'],
])
// 所有作业类型
export const allJobStatus = new Map([
    ['XZ', '熏蒸'],
    ['EZ', '二转'],
    ['ZX', '装箱'],
    ['CX', '拆箱'],
    ['ZC', '装船'],
    ['XC', '卸船'],
    ['OTHER', '其它'],
])
// 所有作业类型
export const allJobStatusNew = new Map([
    ['ZC', '装船'],
    ['XC', '卸船'],
    ['ZX', '装箱'],
    ['CX', '拆箱'],
    ['XZ', '熏蒸'],
    ['EZ', '二转'],
    ['T', '提箱放行'],
    ['C', '拆箱放行']
])
// 特殊箱作业类型
export const tallyPlanStatus = new Map([
    ['ONE', '未作业'],
    ['TWO', '作业中'],
    ['THREE', '已完成'],
    ['FOUR', '已核对'],
])

// 港口枚举
export const portCode = new Map([
    ["GYG", "果园港"],
    ["CTG", "寸滩港"],
    ["JLG", "玖龙港"],
    ["LWG", "理文港"],
    ["WZG", "万州港"],
    ["CSG", "长寿港"],
    ["FLG", "涪陵港"],
    ["XG", "新港"]
])

// 船计划类型
export const shipPlanType = new Map([
    ['ZC', '装船'],
    ['XC', '卸船'],
])

// 船计划类型
export const enchaseWayType = new Map([
    ['GZ', '港装'],
    ['CZ', '厂装'],
])

// 是否中转
export const isChange = new Map([
    ['1', '是'],
    ['0', '否'],
])

// 残损代码
export const dageType = new Map([
    ["B", "破损"],
    ["DE", "变形"],
    ["M", "灭失"],
    ["H", "洞"],
    ["D", "凹损"],
    ["BL", "凸损"],
    ["C", "刮伤"],
    ["", "其他"],
])

// 放行类型
export const releaseType = new Map([
    ['T', '提箱放行'],
    ['C', '拆箱放行'],
])

// 结算方式
export const settlementType = new Map([
    ['M', '月结'],
    ['C', '现结'],
])
// 是否残损
export const isDamagedType = new Map([
    ['0', '否'],
    ['1', '是'],
])

// 规则-业务模式
export const businessModule = new Map([
    ['JZX', '集装箱'],
    ['JH', '件货'],
    ['SH', '散货'],
    ['WL', '外理'],
])
// 规则-计费指标
export const feeUnit = new Map([
    ["A", "月累计量"],
    ["B", "月累计TEU"],
    ["C", "箱次"],
    ["D", "TEU"],
    ["E", "吨"],
    ["F", "车皮"],
])
// 规则-操作符
export const ruleOperator = new Map([
    ['equal', '等于'],
    ['nEqual', '不等于'],
    ['gEqual', '大于等于'],
    ['lEqual', '小于等于'],
    ['gThan', '大于'],
    ['lThan', '小于'],
    ['like', 'LIKE'],
    ['nLike', 'NOTLIKE'],
    ['in', 'IN'],
    ['nIn', 'NOTIN'],
])
// 操作符2
export const ruleOperatorType = new Map([
    ['equal', '等于'],
    ['nEqual', '不等于'],
    ['in', '包含'],
    ['nIn', '不包含'],
    ['gEqual', '大于等于'],
    ['lEqual', '小于等于'],
    ['gThan', '大于'],
    ['lThan', '小于'],
])
// 规则-连接符
export const ruleConnect = new Map([
    ['AND', 'AND'],
    ['OR', 'OR'],
])
// 残损代码
export const damaged = new Map([
    ["B", "破损"],
    ["DE", "变形"],
    ["M", "灭失"],
    ["H", "洞"],
    ["D", "凹损"],
    ["BL", "凸损"],
    ["C", "刮伤"],
    ["OTHER", "其他"],
])

//日报月报

export const planReport = new Map([
    ["Total", "合计"],
    ["CX", "拆箱理货量"],
    ["Pass", "提箱放行量"],
    ["ZX", "装箱理货量"],
])

// 所属仓库
export const warehouse = new Map([
    ['A01', '果园库'],
    ['A02', '港华库'],
])

// 仓库类型
export const areaType = new Map([
    ['XN', '虚拟仓库'],
    ['JG', '监管仓库'],
])

// 原则
export const principle = new Map([
    ['HZ', '货主'],
    ['PM', '品名'],
    ['GL', '管理方式'],
    ['JL', '计量方式'],
    ['RK', '入库方式'],
    ['G1', '规格1'],
    ['G2', '规格2'],
    ['G3', '规格3'],
    ['CZ', '材质'],
    ['SCCJ', '生产厂家']
])

// 优先级
export const priority = new Map([
    ['0', '不可忽略'],
    ['1', '1'],
    ['2', '2'],
    ['3', '3'],
    ['4', '4'],
    ['5', '5'],
    ['6', '6'],
    ['7', '7'],
    ['8', '8'],
    ['9', '9']
])



// 限制因素
export const limitFactor = new Map([
    ['W', '重量'],
    ['N', '件数'],
])

// 日历类型
export const calendarType = new Map([
    ['SOLAR', '阳历'],
    ['LUNAR', '阴历'],
])

// 业务模式
export const businessMode = new Map([
    ['JH', '件货业务'],
    ['SH', '散货业务'],
    ['JZX', '集装箱业务'],
    ['WL', '外理业务'],
])


// 规则条件
export const ruleCondition = new Map([
    ['RK', '入库方式'],
    ['YS', '运输方式'],
    ['CK', '出库方式'],
])

// 规则条件2
export const ruleCondition2 = new Map([
    ['SY', '水运入库'],
    ['TH', '提货入库'],
    ['HC', '火车入库'],
    ['QC', '汽车入库'],
])

// 卡类型
export const cardType = new Map([
    ['C', '车卡'],
    ['MS', '月结卡'],
    ['P', '员工卡'],
])

// 使用状态
export const useStatus = new Map([
    ['ENABLED', '可用'],
    ['USED', '已用'],
    ['DISABLED', '不可用'],
])


// 账户类型
export const accountTypes = new Map([
    ['CREDIT', '信誉账户'],
    ['NORMAL', '普通账户'],
    ['MONTHLY', '月结账户'],
    // ['QF','欠费客户'],
])

// 账户性质
export const accountNature = new Map([
    ['CONTRACTED', '合同客户'],
    ['OPENED', '开户客户'],
    ['SEMTTLEMENT', '结算客户']
])

// 新增账户
export const newAccountNature = new Map([
    // ['CONTRACTED', '合同客户'],
    ['OPENED', '开户客户'],
    ['SEMTTLEMENT', '结算客户']
])

// 逾期类型
export const overdueType = new Map([
    ['AMOUNT', '欠费金额'],
    ['DAYS', '逾期天数'],
    ['WU', '无']
])

//
export const inOutType = new Map([
    ["IN", "入库"],
    ["OUT", "出库"],
])
//消息类型
export const messageType = new Map([
    ["1", "普通消息"],
    ["2", "设备消息"],
    ["3", "警告消息"],
])

// 指令状态
export const taskStatus = new Map([
    ["1", "未作业"],
    ["2", "作业中"],
    ["3", "已完成"]
])

// 提还类型
export const thType = new Map([
    ["TZ", "提重"],
    ["TK", "提空"],
    ["HC", "回场"],
    ["JC", "外进"]
])






//用箱类型
export const containerUseType = new Map([
    ["SELF", "自备箱"],
    ["TRAIN", "铁路箱"],
])

//订单状态
export const orderStatus = new Map([
    ["UNSUBMIT", "待提交"],
    ["UNACCEPT", "待受理"],
    ["REFUSED", "已拒绝"],
    ["INEXECUTION", "执行中"],
    ["COMPLETED", "已完成"],
    ["ORDER", "下单"],
    ["UNORDERBOX", "未订箱"],
    ["REQUESTED", "已申请"],
])

//订舱状态
export const orderWagonState = new Map([
    ["1", "未订舱"],
    ["2", "已申请"],
    ["3", "已完成"],
    ["0", "无需订舱"]
])

//订箱状态
export const orderContainerState = new Map([
    ["1", "未订箱"],
    ["2", "已申请"],
    ["3", "已完成"],
    ["0", "无需订箱"]
])

//作业状态
export const ZYStatus = new Map([
    ["UNWORK", "未集并"],
    ["COMPILED", "已集并"],
    ["APPLED", "已请车"],
    ["PLANED", "装车已计划"],
    ["COMPLETED", "已完成"]
])

//状态类型
export const statusType = new Map([
    ["ORDER", "订单状态"],
    ["CONTAINER", "订箱状态"],
])

//操作类型
export const operateCate = new Map([
    ["CREATE", "下单"],
    ["SUBMIT", "提交订单"],
    ["ACCEPT", "受理单"],
    ["ORDERBOX", "铁路订箱"],
    ["FIXEDBOX", "铁路已订箱"],
    ["DEPART", "已发车"],
])



// WEBPACK FOOTER //
// ./src/assets/dict.js